import { Box, Typography } from "@mui/material";
import { PointsActionTaskerRewardCompleted } from "@t3/shared";
import { BaseTransactionCard } from "./BaseTransactionCard";
import { DateDisplay, PointsBadge } from "./TransactionCardComponents";

interface TaskerRewardCardProps {
  action: PointsActionTaskerRewardCompleted;
  createdAt: string;
}

export const TaskerRewardCard = ({
  action,
  createdAt,
}: TaskerRewardCardProps) => {
  const typeMeta = action.typeMeta;
  // Fallback for old data that might not have points
  const pointsDisplay = typeMeta.points ?? "—";

  return (
    <BaseTransactionCard minHeight={120} dataCypress="history-tasker-card">
      <Box display="flex" flexDirection="column" height="100%">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb="auto"
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: "text.primary",
            }}
            data-cypress="tasker-card-title"
          >
            Tasker
          </Typography>
          <PointsBadge points={pointsDisplay} label="" variant="rewarded" />
        </Box>
        <Box mt={1.5}>
          <DateDisplay date={createdAt} />
        </Box>
      </Box>
    </BaseTransactionCard>
  );
};
